package com.exura.features.publicplans.di

import com.exura.features.publicplans.data.remote.dto.AnonymousPublicPlanOrderDto
import com.exura.features.publicplans.data.remote.dto.ProviderPublicPlanDto
import com.exura.features.publicplans.data.remote.dto.PublicPlanServingEntryDto
import com.exura.features.publicplans.data.repository.ProviderPublicPlanRepositoryImpl
import com.exura.features.publicplans.domain.PublicPlansConstants
import com.exura.features.publicplans.domain.model.AnonymousPublicPlanOrder
import com.exura.features.publicplans.domain.model.ProviderPublicPlan
import com.exura.features.publicplans.domain.model.PublicPlanServingEntry
import com.exura.features.publicplans.domain.repository.ProviderPublicPlanRepository
import com.exura.features.publicplans.domain.usecase.CreateNewPublicPlanUseCase
import com.exura.features.publicplans.domain.usecase.DisablePublicPlanSharingUseCase
import com.exura.features.publicplans.domain.usecase.EnablePublicPlanSharingUseCase
import com.exura.features.publicplans.domain.usecase.GetPublicPlanOrdersUseCase
import com.exura.features.publicplans.domain.usecase.GetPublicPlanServingsUseCase
import com.exura.features.publicplans.domain.usecase.GetPublicPlanUseCase
import com.exura.features.publicplans.domain.usecase.ListPublicPlansUseCase
import com.exura.features.publicplans.domain.usecase.RefreshPlanStatisticsUseCase
import com.exura.features.publicplans.domain.usecase.ReplacePlanDefinitionUseCase
import com.exura.features.storage.data.repository.FirebaseEntityRepository
import com.exura.features.storage.domain.repository.EntityRepository
import kotlinx.serialization.modules.SerializersModule
import org.koin.core.qualifier.named
import org.koin.dsl.module

val providerPublicPlansModule = module {
    single<EntityRepository<ProviderPublicPlan>>(named("ProviderPublicPlan")) {
        FirebaseEntityRepository(
            userDataPrefixUseCase = get(),
            collectionName = PublicPlansConstants.Firestore.PROVIDER_PUBLIC_PLANS_COLLECTION_NAME,
            factory = ProviderPublicPlan,
            serializer = ProviderPublicPlanDto.serializer(),
            dtoSerializersModule = SerializersModule {  },
        )
    }

    single<EntityRepository<PublicPlanServingEntry>>(named("PublicPlanServingEntry")) {
        FirebaseEntityRepository(
            userDataPrefixUseCase = get(),
            collectionName = PublicPlansConstants.Firestore.PROVIDER_PUBLIC_PLANS_SERVINGS_SUBCOLLECTION,
            factory = PublicPlanServingEntry,
            serializer = PublicPlanServingEntryDto.serializer(),
            dtoSerializersModule = SerializersModule {  },
        )
    }

    single<EntityRepository<AnonymousPublicPlanOrder>>(named("AnonymousPublicPlanOrder")) {
        FirebaseEntityRepository(
            userDataPrefixUseCase = get(),
            collectionName = PublicPlansConstants.Firestore.PROVIDER_PUBLIC_PLANS_ORDERS_SUBCOLLECTION,
            factory = AnonymousPublicPlanOrder,
            serializer = AnonymousPublicPlanOrderDto.serializer(),
            dtoSerializersModule = SerializersModule {  },
        )
    }

    single<ProviderPublicPlanRepository> {
        ProviderPublicPlanRepositoryImpl(
            publicPlanStorage = get((named("ProviderPublicPlan"))),
            publicPlanServingStorage = get((named("PublicPlanServingEntry"))),
            publicPlanOrderStorage = get((named("AnonymousPublicPlanOrder"))),
        )
    }

    factory<CreateNewPublicPlanUseCase> { CreateNewPublicPlanUseCase(get(), get(), get(), get()) }
    factory<ReplacePlanDefinitionUseCase> { ReplacePlanDefinitionUseCase(get(), get(), get(), get()) }

    factory<DisablePublicPlanSharingUseCase> { DisablePublicPlanSharingUseCase(get(), get()) }
    factory<EnablePublicPlanSharingUseCase> { EnablePublicPlanSharingUseCase(get(), get()) }

    factory<RefreshPlanStatisticsUseCase> { RefreshPlanStatisticsUseCase(get()) }

    factory<GetPublicPlanOrdersUseCase> { GetPublicPlanOrdersUseCase(get()) }
    factory<GetPublicPlanServingsUseCase> { GetPublicPlanServingsUseCase(get()) }
    factory<ListPublicPlansUseCase> { ListPublicPlansUseCase(get()) }
    factory<GetPublicPlanUseCase> { GetPublicPlanUseCase(get()) }
}
